




















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { Id } from '../../types/eid';
import { CriiptoStatus } from '../../types/enums/criipto-status';
import { criiptoBaseUrl } from '../../constants/criipto';
import { IdService } from '../../../api/signing/services/eid.service';

export default defineComponent({
  props: {
    selectedEId: {
      type: Object as PropType<Id>,
      required: true,
    },
    documentId: {
      type: String,
      required: true,
    },
    recipientId: {
      type: String,
      required: true,
    },
    status: {
      type: String as PropType<CriiptoStatus>,
      required: true,
    },
  },
  setup(props) {
    const showIframe = computed(
      (): boolean =>
        frameUrl.value && [CriiptoStatus.Default, CriiptoStatus.Error].includes(props.status)
    );

    const frameHeight = computed((): number => props.selectedEId.height);

    const frameWidth = computed((): number => {
      const { width } = props.selectedEId;
      const eidHolder: Element = document.getElementsByClassName('eid-holder')[0];
      if (!eidHolder) {
        return width;
      }
      const clientWidth: number = eidHolder.getBoundingClientRect().width;
      if (clientWidth < props.selectedEId.width) {
        return clientWidth;
      }
      return width;
    });

    const frameUrl = computed((): string => {
      const { key } = props.selectedEId;
      const subPath: string = IdService.getPath(key);
      return `${criiptoBaseUrl}/${subPath}/login?documentId=${props.documentId}&recipientId=${props.recipientId}`;
    });

    return {
      CriiptoStatus,
      showIframe,
      frameHeight,
      frameWidth,
      frameUrl,
    };
  },
});
